/**
 * Store
 */

import '@store';

/**
 * Core
 */

import RFCanvas from '@core/rf-canvas/rf-canvas.svelte';
import RFCollections from '@core/rf-collections/rf-collections.svelte';
import RFExplorer from '@core/rf-explorer/rf-explorer.svelte';
import RFMetadata from '@core/rf-metadata/rf-metadata.svelte';
import RFObserver from '@core/rf-observer/rf-observer.svelte';
import RFInspector from '@core/rf-inspector/rf-inspector.svelte';
import RFExporter from '@core/rf-exporter/rf-exporter.svelte';

/**
 * Elements
 */

import RFText from '@core/elements/rf-text/rf-text.svelte';
import RFLegend from '@core/elements/rf-legend/rf-legend.svelte';
import RFMarker from '@core/rf-observer/rf-marker.svelte';
import RFCanvasAnnotation from '@core/rf-canvas-annotation/rf-canvas-annotation.svelte';

/**
 * Modules
 */

import RFHero from '@modules/rf-hero/rf-hero.svelte';
import RFMirror from '@modules/rf-mirror/rf-mirror.svelte';
import RFGrid from '@modules/rf-grid/rf-grid.svelte';
import RFCarrousel from '@modules/rf-carrousel/rf-carrousel.svelte';
import RFCarrouselSlide from '@modules/rf-carrousel/rf-carrousel-slide.svelte';
import RFSplitFlow from '@modules/rf-split-flow/rf-split-flow.svelte';
import RFOverlay from '@modules/rf-overlay/rf-overlay.svelte';
import RFParallax from '@modules/rf-parallax/rf-parallax.svelte';
import RFBookReader from '@modules/rf-book-reader/rf-book-reader.svelte';
import RFLightTable from '@modules/rf-light-table/rf-light-table.svelte';
import RFLightTableElement from '@modules/rf-light-table/rf-light-table-element.svelte';

/**
 * Scss
 */

import '@scss/core/rf-modules.scss';
import '@scss/core/rf-theme.scss';
import '@scss/core/rf-tokens.scss';

export default {
	RFCanvas,
	RFCollections,
	RFInspector,
	RFExporter,
	RFText,
	RFLegend,
	RFMarker,
	RFMirror,
	RFObserver,
	RFExplorer,
	RFMetadata,
	RFHero,
	RFGrid,
	RFCarrousel,
	RFCarrouselSlide,
	RFSplitFlow,
	RFOverlay,
	RFParallax,
	RFBookReader,
	RFLightTable,
	RFLightTableElement,
};
